module.exports = __webpack_public_path__ + "static/media/CopyFiles.e5a26d2d.svg";